export const checkStyleObjectDataValid = (styleData: Record<string, unknown>): boolean => {
  if (
    typeof styleData === 'object' &&
    Object.keys(styleData).length > 0 &&
    !Object.values(styleData).every(styleVal => styleVal === undefined)
  ) {
    return true;
  }
  return false;
};
